<template>
  <div>
    <h3>{{ mailingList.name }}</h3>
    <data-input
      v-model="applicantInMailingList"
      label="in Liste"
      name="sync"
      type="bool"
    />
    <table>
      <tr>
        <th>Zuletzt Geändert:</th>
        <td>{{ timeFromTimestamp(mailingList.lastChanged) }}</td>
      </tr>
      <tr>
        <th>Letzte Mail:</th>
        <td>{{ timeFromTimestamp(mailingList.lastMailing) }}</td>
      </tr>
      <template v-if="applicantInMailingList">
        <tr>
          <th>Abgelehnte Emails</th>
          <td>{{ localStatus.bounced }}</td>
        </tr>
        <tr v-if="localStatus.activated <= localStatus.deactivated">
          <th><i class="fas fa-times"></i>Inaktiv seit:</th>
          <td>{{ timeFromTimestamp(localStatus.deactivated) }}</td>
        </tr>
        <tr v-else>
          <th><i class="fas fa-check"></i>Aktiv seit:</th>
          <td>{{ timeFromTimestamp(localStatus.activated) }}</td>
        </tr>
        <tr>
          <th>click rate</th>
          <td>{{ localStatus.clickRate }}</td>
        </tr>
        <tr>
          <th>conversion rate</th>
          <td>{{ localStatus.converisonRate }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ localStatus.email }}</td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  emits: ["updated"],
  props: {
    mailingList: {
      type: Object,
      required: true
    },
    cleverreachStatus: {
      type: Array,
      required: true
    },
    applicantId: {
      type: String,
      required: true
    }
  },
  computed: {
    applicantInMailingList: {
      get() {
        let result = false;
        for (const stat of this.cleverreachStatus) {
          if (stat.groupID && stat.groupID == this.mailingList.cleverreachID) {
            return true;
          }
        }
        return result;
      },
      async set(value) {
        if (value) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation($applicantID: ID!, $mailingListId: String!) {
                addApplicantToMailingList(
                  applicantID: $applicantID
                  mailingListId: $mailingListId
                ) {
                  id
                }
              }
            `,
            variables: {
              applicantID: this.applicantId,
              mailingListId: this.mailingList.id
            }
          });
          this.$emit("updated");
        } else {
          await this.$apollo.mutate({
            mutation: gql`
              mutation($applicantID: ID!, $mailingListId: String!) {
                removeApplicantFromMailingList(
                  applicantID: $applicantID
                  mailingListId: $mailingListId
                )
              }
            `,
            variables: {
              applicantID: this.applicantId,
              mailingListId: this.mailingList.id
            }
          });
          this.$emit("updated");
        }
      }
    },
    localStatus() {
      for (const stat of this.cleverreachStatus) {
        if (stat.groupID && stat.groupID == this.mailingList.cleverreachID) {
          return stat;
        }
      }
      return null;
    }
  },
  methods: {
    timeFromTimestamp(stamp) {
      if (stamp != 0) {
        return new Date(stamp * 1000).toLocaleString();
      }
      return "Nie";
    }
  }
};
</script>
